<template>
  <b-card clas="mb-2">
    <b-tabs>
      <b-tab id="tab-gcc-1" title="รายละเอียด">
        <b-card v-if="gccObj.rootobject" class="m-1">
          <b-form-group label="รหัสเรื่อง" label-cols-md="3">
            <span
              class="row col-form-label"
              v-text="': ' + gccObj.rootobject.case_id"
            />
          </b-form-group>
          <b-form-group label="เลขเรื่อง" label-cols-md="3">
            <span
              class="row col-form-label"
              v-text="': ' + gccObj.rootobject.case_code"
            />
          </b-form-group>
          <b-form-group label="จุดประสงค์" label-cols-md="3">
            <span
              class="row col-form-label"
              v-text="': ' + gccObj.rootobject.objective_text"
            />
          </b-form-group>
          <b-form-group label="ประเภท" label-cols-md="3">
            <span
              class="row col-form-label"
              v-text="': ' + gccObj.rootobject.type_text"
            />
          </b-form-group>
          <b-form-group label="สถานะ" label-cols-md="3">
            <span
              class="row col-form-label"
              v-text="': ' + gccObj.rootobject.status_text"
            />
          </b-form-group>
          <b-form-group
            v-if="gccObj.rootobject.customer"
            label="ประเภทผู้ร้อง"
            label-cols-md="3"
          >
            <span
              class="row col-form-label"
              v-text="
                ': ' +
                  (gccObj.rootobject.customer.is_secret == 'T'
                    ? 'ปกปิด'
                    : gccObj.rootobject.customer.customer_type_text)
              "
            />
          </b-form-group>
          <div v-if="gccObj.rootobject.customer">
            <b-card
              v-if="gccObj.rootobject.customer.is_secret === 'F'"
              class="m-1 border border-primary"
            >
              <b-form-group label="เลขประจำตัวประชาชน" label-cols-md="3">
                <span
                  class="row col-form-label"
                  v-text="
                    ': ' + gccObj.rootobject.customer.citizen_id !== null
                      ? gccObj.rootobject.customer.citizen_id
                      : ''
                  "
                />
              </b-form-group>
              <b-form-group label="ชื่อ-นามสกุล" label-cols-md="3">
                <span
                  class="row col-form-label"
                  v-text="
                    ': ' +
                      gccObj.rootobject.customer.salutation_th +
                      gccObj.rootobject.customer.firstname_th +
                      gccObj.rootobject.customer.lastname_th
                  "
                />
              </b-form-group>
              <b-form-group
                v-if="gccObj.rootobject.customer.salutation_en !== null"
                label="ชื่อ-นามสกุล (ภาษาอังกฤษ)"
                label-cols-md="3"
              >
                <span
                  class="row col-form-label"
                  v-text="
                    ': ' +
                      gccObj.rootobject.customer.salutation_en +
                      gccObj.rootobject.customer.firstname_en +
                      gccObj.rootobject.customer.lastname_en
                  "
                />
              </b-form-group>
              <b-form-group label="เพศ" label-cols-md="3">
                <span
                  class="row col-form-label"
                  v-text="
                    ': ' + gccObj.rootobject.customer.gender_text !== null
                      ? gccObj.rootobject.customer.gender_text
                      : ''
                  "
                />
              </b-form-group>
              <b-form-group label="วันเดือนปีเกิด" label-cols-md="3">
                <span
                  class="row col-form-label"
                  v-text="
                    ': ' + gccObj.rootobject.customer.birthday !== null
                      ? gccObj.rootobject.customer.birthday
                      : ''
                  "
                />
              </b-form-group>
              <b-form-group label="ที่อยู่" label-cols-md="3">
                <span
                  class="row col-form-label"
                  v-text="
                    ': ' +
                      gccObj.rootobject.customer.address +
                      ' ' +
                      (gccObj.rootobject.customer.subdistrict_text !== null
                        ? gccObj.rootobject.customer.subdistrict_text
                        : '') +
                      ' ' +
                      (gccObj.rootobject.customer.district_text !== null
                        ? gccObj.rootobject.customer.district_text
                        : '') +
                      ' ' +
                      (gccObj.rootobject.customer.province_text !== null
                        ? gccObj.rootobject.customer.province_text
                        : '') +
                      ' ' +
                      (gccObj.rootobject.customer.postcode !== null
                        ? gccObj.rootobject.customer.postcode
                        : '')
                  "
                />
              </b-form-group>
              <b-form-group label="ประเทศ" label-cols-md="3">
                <span
                  class="row col-form-label"
                  v-text="': ' + gccObj.rootobject.customer.country_name"
                />
              </b-form-group>
              <b-form-group
                v-if="gccObj.rootobject.customer.nationality_name !== null"
                label="สัญชาติ"
                label-cols-md="3"
              >
                <span
                  class="row col-form-label"
                  v-text="': ' + gccObj.rootobject.customer.nationality_name"
                />
              </b-form-group>
              <b-form-group label="รายละเอียดเพิ่มเติม" label-cols-md="3">
                <span
                  v-for="(item, key) in gccObj.rootobject.customer
                    .list_customer_detail"
                  :key="key"
                  class="row col-form-label"
                  v-text="': ' + item.detail"
                />
              </b-form-group>
              <b-form-group label="หมายเหตุ" label-cols-md="3">
                <span
                  class="row col-form-label"
                  v-text="
                    ': ' + gccObj.rootobject.customer.remark !== null
                      ? gccObj.rootobject.customer.remark
                      : ''
                  "
                />
              </b-form-group>
            </b-card>
          </div>
          <b-form-group label="หัวข้อ" label-cols-md="3">
            <span
              class="row col-form-label"
              v-text="': ' + gccObj.rootobject.summary"
            />
          </b-form-group>
          <b-form-group label="รายละเอียด" label-cols-md="3">
            <span
              class="row col-form-label"
              v-text="': ' + gccObj.rootobject.detail"
            />
          </b-form-group>
          <b-form-group label="วันที่รับเรื่อง" label-cols-md="3">
            <span
              class="row col-form-label"
              v-text="': ' + gccObj.rootobject.showDateTime"
            />
          </b-form-group>
          <b-form-group label="สถานะการส่งต่อ" label-cols-md="3">
            <span
              class="row col-form-label"
              v-text="': ' + gccObj.rootobject.summary_result"
            />
          </b-form-group>
        </b-card>
      </b-tab>
      <b-tab id="tab-gcc-2" title="ประวัติการดำเนินการ">
        <b-card v-if="gccObj.rootobject" class="m-1">
          <b-row>
            <b-col
              v-for="(item, i) in gccObj.class1"
              :key="item.contact_id"
              cols="12"
              class="list-group list-group-circle text-left m-1"
            >
              <div class="d-flex list-group-item">
                <div class="">
                  <h5 class="mb-0">{{ i + 1 }}. {{ item.org_text }}</h5>
                  <!-- <small class="text-muted">{{ item.createTracking }}</small> -->
                </div>
                <div class="col ml-auto">
                  <hr class="my-12 bg-dark" />
                </div>
              </div>

              <div class="d-flex justify-content-round ml-2 mr-5">
                <div class="w-100">
                  <div class="d-flex justify-content-between ml-2">
                    <span class="mb-0">
                      {{ item.operating_type_text
                      }}{{ item.operating_objective_text }}
                    </span>
                  </div>

                  <div class="d-flex justify-content-between ml-2">
                    <span class="mb-0">
                      {{ item.detail }}
                    </span>
                  </div>

                  <div class="d-flex justify-content-between ml-2 text-left">
                    <small class="mb-0">
                      {{
                        item.operating_date === null
                          ? item.operating_date
                          : item.operating_date
                      }}</small
                    >
                    <small class="d-flex justify-content-between ml-2">
                      <span>
                        <b> {{ item.created_by_text }} </b>
                      </span>
                    </small>
                  </div>
                  <hr class="my-12 bg-dark w-100" />
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab id="tab-gcc-3" title="เอกสารตามสถานะ">
        <b-row>
          <b-col cols="6" class="mt-2 text-center">
            ชื่อไฟล์
          </b-col>
          <b-col cols="6" class="mt-2 text-center">
            ประเภทไฟล์
          </b-col>
          <hr />

          <div class="col-12 m-1">
            <b-row
              v-for="file in extractAttachFile()"
              :key="file.attachment_id"
              class="col-12 m-1"
            >
              <b-col cols="6">
                <a href="#" @click="getFileBase64(file)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-arrow-down-circle"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="8 12 12 16 16 12" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                  </svg>
                  {{ file.file_name }}
                </a>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-center">
                {{ file.doc_type_str }} {{ file.doc_type_text }}
              </b-col>
            </b-row>
          </div>
        </b-row>
      </b-tab>
    </b-tabs>
    <slot></slot>
  </b-card>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BFormInput,
  BListGroup,
  BListGroupItem,
  BButton,
  BCard,
  BTab,
  BTabs,
} from "bootstrap-vue";

import * as gccStore from "@/store/api/gcc/index.js";

export default {
  components: {
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BCard,
    BTab,
    BTabs,
  },
  props: {
    gccObj: {},
  },
  methods: {
    extractAttachFile() {
      try {
        //return this.gccObj.rootobject.list_case_attachment;
        let attachFiles = [];
        this.gccObj.class1.forEach((value) => {
          if (value.attachments !== null) {
            attachFiles.push(...value.attachments);
          }
        });
        return attachFiles;
      } catch (ex) {
        return [];
      }
    },
    getFileBase64(attachFile) {
      try {
        gccStore.getApiAttachment(attachFile.attachment_id).then((response) => {
          //let base64String = response.data.data.file_type + "," + response.data.data.file_content
          var a = document.createElement("a"); //Create <a>
          a.href =
            "data:" +
            response.data.data.file_type +
            ";base64," +
            response.data.data.file_content; //Image Base64 Goes here
          a.download = attachFile.file_name; //File name Here
          a.target = "_blank";
          a.click();
        });
      } catch (ex) {
        console.log(ex);
      }
    },
  },
};
</script>

<style></style>
